// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCampaignEvents, getCustomEvents, getHasFootfallAttribution } from '@/store/selectors/reporting.selectors';
import { getStaticReports } from '../Reporting/helpers';
import { useReporting } from '../Reporting/ReportingContext';
import { prepareTableHeaders } from '../reportingExport.helpers';
import { StatsTablesSection } from '.';

import type { StatsType } from '@/ts-types/reporting.types';

function StatsTablesContent() {
  const intl = useIntl();
  const {
    reporting: { cartography, sectionsVisibility, selectedCampaigns, showGTotal, stats, user, userRoles }
  } = useReporting();

  const customEvents = useSelector(getCustomEvents);
  const campaignAdActions = useSelector(getCampaignEvents);
  const hasFootfall = useSelector(getHasFootfallAttribution);

  const staticReports = getStaticReports(selectedCampaigns, intl.formatMessage);

  const dataByType: Record<StatsType, Record<string, unknown>[]> = {
    footfallAttribution: prepareTableHeaders({
      campaignEvents: campaignAdActions,
      campaigns: selectedCampaigns,
      cartography,
      customEvents,
      intl,
      showGTotal,
      stats,
      statsGroups: [],
      statsType: 'footfallAttribution',
      user,
      userRoles
    }),
    stats: prepareTableHeaders({
      campaignEvents: campaignAdActions,
      campaigns: selectedCampaigns,
      cartography,
      customEvents,
      intl,
      showGTotal,
      stats,
      statsGroups: [],
      statsType: 'stats',
      user,
      userRoles
    }),
    viewability: prepareTableHeaders({
      campaignEvents: campaignAdActions,
      campaigns: selectedCampaigns,
      cartography,
      customEvents,
      intl,
      showGTotal,
      stats,
      statsGroups: [],
      statsType: 'viewability',
      user,
      userRoles
    })
  };

  return (
    <div
      className="reportingBox"
      style={{
        display:
          sectionsVisibility.reportingStatsTable ||
          sectionsVisibility.reportingViewabilityTable ||
          (sectionsVisibility.reportingFootfallAttributionTable && hasFootfall)
            ? 'block'
            : 'none'
      }}
    >
      <StatsTablesSection hasFootfall={hasFootfall} staticReports={staticReports} statsTableColumns={dataByType} />
    </div>
  );
}

export default StatsTablesContent;
